import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig, profile } from 'config/config';

export default class tableFlujoCajaResumidoView extends JetView {
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define a date formatting function based on the application's configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Initialize a variable for left split positioning
        var leftSplit = 1;

        // Extend the webix data filter to create a summary tree column filter
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the display of the summary tree column.
                 * @param {Object} master - The master data view.
                 * @param {Object} node - The current node being processed.
                 * @param {Object} value - The value object containing column information.
                 */
                refresh: function(master, node, value) {
                    // Initialize result variables for summation
                    var result = 0;
                    var resultFormat = 0;

                    // Iterate through each data object in the master data view
                    master.data.each(function(obj) {
                        // Sum the values of the specified column for level 1 objects
                        if (obj.$level == 1) result += obj[value.columnId];
                    });

                    // Format the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result); // Format as integer
                    } else {
                        resultFormat = webix.i18n.priceFormat(result); // Format as price
                    }

                    // Update the inner HTML of the node with the formatted result
                    node.firstChild.innerHTML = resultFormat;
                },
            },
            // Inherit properties and methods from the summColumn filter
            webix.ui.datafilter.summColumn,
        );
        // Waits for the Webix library to be ready before executing the function
        webix.ready(function() {
            // Checks the screen dimensions to determine layout configuration
            if (screen.width < 500 || screen.height < 500) {
                // Sets leftSplit to 0 for small screens
                leftSplit = 0;
            } else {
                // Sets leftSplit to 1 for larger screens
                leftSplit = 1;
            }
        });

        // Check if the selected partner is '0'
        if (devConfig.getPartnerSelected() == '0') {
            return {
                view: 'treetable', // Define the view type as a tree table
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique identifier for the component
                bready: function() { // Function to execute when the table is ready
                    this.openAll(); // Open all rows in the tree table
                },
                scrollY: true, // Enable vertical scrolling
                columns: [ // Define the columns of the tree table
                    {
                        id: 'Fecha', // Column ID
                        header: _('Fecha'), // Column header with translation
                        width: 300, // Column width
                        template: function(obj, common) { // Template function for cell rendering
                            if (obj.$group) return common.treetable(obj, common) + obj.value; // Render group rows
                            return obj.Fecha; // Return the date value
                        },
                        footer: _('Total:'), // Footer content with translation
                    },
                    {
                        id: 'detailTittle', // Column ID for detail title
                        header: '', // No header
                        width: 50, // Column width
                        height: 25, // Column height
                        tooltip: _('Detalles'), // Tooltip with translation
                        template: function(obj) { // Template function for detail icon
                            if (obj.$level == 5) {
                                return '<span placeholder=\'Imprimir\' class=\'webix_icon wxi-close printer\'></span>'; // Print icon for level 5
                            } else {
                                return ''; // No icon for other levels
                            }
                        },
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets', // Tickets count column
                        header: _('Cantidad Tickets'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.intFormat, // Format for integer values
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivoDeportivo', // Recharge entry value column
                        header: _('Entradas en Efectivo - Apuestas Deportivas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 160, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivoCasino', // Recharge entry value column
                        header: _('Entradas en Efectivo - Apuestas Virtuales'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 160, // Column width
                    },
                    {
                        id: 'VoidedPlacedBets', // Voided bets column
                        header: _('Apuestas Anuladas'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto', // Net cash entries value column
                        header: _('V.Entradas Efectivo Neto'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorEntradasBonoTC', // Bonus/T.C entries value column
                        header: _('V.Entradas Bono/T.C'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 140, // Column width
                    },
                    {
                        id: 'ValorEntradasTraslados', // Transfers entries value column
                        header: _('V.Entradas Traslados'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 145, // Column width
                    },
                    {
                        id: 'ValorEntradasRecargas', // Reload entries value column
                        header: _('V.Entradas Recargas'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 142, // Column width
                    },
                    {
                        id: 'RecargasAnuladas', // Voided reloads column
                        header: _('Recargas Anuladas'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 142, // Column width
                    },
                    {
                        id: 'Tax', // Tax column
                        header: _('Impuestos'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 142, // Column width
                    },
                    {
                        id: 'ValorSalidaEfectivoDeportivas', // Recharge entry value column
                        header: _('Salida en Efectivo - Apuestas Deportivas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 160, // Column width
                    },
                    {
                        id: 'ValorSalidaEfectivoCasino', // Recharge entry value column
                        header: _('Salida en Efectivo - Apuestas Virtuales'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 160, // Column width
                    },
                    {
                        id: 'VoidedPaidBets', // Voided paid bets column
                        header: _('Apuestas Pagadas Anuladas'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto', // Net cash exits value column
                        header: _('V.Salidas Efectivo Neto'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasTraslados', // Transfers exits value column
                        header: _('V.Salidas Traslados'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorSalidasNotasRetiro', // Withdrawal notes exits value column
                        header: _('V.Salidas N.Retiro'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 142, // Column width
                    },
                    {
                        id: 'Saldo', // Balance column
                        header: _('Saldo'), // Column header with translation
                        footer: { content: 'summTreeColumn' }, // Footer content for summation
                        format: webix.i18n.priceFormat, // Format for price values
                        exportType: 'number', // Export type for this column
                        width: 100, // Column width
                    },
                ],
                onClick: { // Event handler for click events
                    printer: function(euv, id) { // Function to handle print icon clicks
                        var vvthis = this; // Reference to the current context
                        webix.confirm({ // Confirmation dialog for printing
                            type: 'confirm-warning',
                            text: _('Advertencia!') + '<br/>' + _('Desea imprimir recibo?'), // Warning message
                            ok: _('Imprimir'), // Confirm button text
                            cancel: _('Salir'), // Cancel button text
                            callback: function(action) { // Callback for confirmation action
                                if (action === true) { // If confirmed
                                    var item = vvthis.getItem(id); // Get the clicked item
                                    console.log(item); // Log the item for debugging
                                    var shtml = // HTML template for the receipt
                                        `<p style="text-align:center;">
                                    &nbsp;
                                  </p>
                                  <p style="text-align:center;">
                                    &nbsp;
                                  </p>
                                  <figure class="table">
                                  <table style="border:1px solid hsl(0, 0%, 0%);">
                                    <tbody>
                                      <tr>
                                        <td style="background-color:hsl(0, 0%, 90%);text-align:center;width:50%;">
                                          <h4>
                                            <span style="color:#6a8759;">` +
                                        _('Flujo Caja Resumido') +
                                        `</span>
                                          </h4>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </figure>
                                <hr>
                                  <figure class="table" style="width:100%;">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Fecha') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        item.Fecha +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('ID Usuario') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        item.UserId +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Moneda') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        item.Moneda +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Cantidad Tickets') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        item.CantidadTickets +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Entradas en Efectivo - Apuestas Deportivas') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorEntradasEfectivoDeportivo) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Entradas en Efectivo - Apuestas Virtuales') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorEntradasEfectivoCasino) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Apuestas Pagadas Anuladas') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.VoidedPaidBets) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Entradas Efectivo Neto') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorEntradasEfectivoNeto) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Entradas Bono/T.C') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorEntradasBonoTC) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Entradas Traslados') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorEntradasTraslados) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Entradas Recargas') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorEntradasRecargas) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Impuestos') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.Tax) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Salidas Efectivo Deportivas') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorSalidaEfectivoDeportivas) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Salidas Efectivo Casino') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorSalidaEfectivoCasino) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Apuestas Pagadas Anuladas') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.VoidedPaidBets) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Salidas Efectivo Neto') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorSalidasEfectivoNeto) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Salidas Traslados') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorSalidasTraslados) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('V.Salidas N.Retiro') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.ValorSalidasNotasRetiro) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                        _('Saldo') +
                                        `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                        webix.i18n.priceFormat(item.Saldo) +
                                        `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </figure>`;
                                    var parameters = { // Parameters for the AJAX request
                                        Template: shtml, // HTML template
                                    };
                                    const json = JSON.stringify(parameters, (key, val) => { // Convert parameters to JSON
                                        if (typeof val === 'string') {
                                            return val
                                                .replace(/ñ/g, '&#241;') // Encode special characters
                                                .replace(/Ñ/g, '&#209;')
                                                .replace(/á/g, '&#225;')
                                                .replace(/Á/g, '&#193;')
                                                .replace(/é/g, '&#233;')
                                                .replace(/É/g, '&#201;')
                                                .replace(/í/g, '&#237;')
                                                .replace(/Í/g, '&#205;')
                                                .replace(/ó/g, '&#243;')
                                                .replace(/Ó/g, '&#211;')
                                                .replace(/ú/g, '&#250;')
                                                .replace(/Ú/g, '&#218;');
                                        }
                                        return val; // Return the value
                                    });
                                    var objJsonB64 = btoa(unescape(encodeURIComponent(json))); // Encode JSON to Base64
                                    webix // AJAX request to send the template
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(devConfig.geturlApi() + '/ApiMkt/Templates/PreviewTemplate', objJsonB64, { // Send request
                                            error: function(text, data, XmlHttpRequest) { // Error handler
                                                webix.message('Error! '); // Show error message
                                            },
                                            success: function(text, data, XmlHttpRequest) { // Success handler
                                                var dat = JSON.parse(text); // Parse response
                                                if (dat.HasError) { // Check for errors in response
                                                    webix.message({
                                                        title: '¡Error!', // Error message title
                                                        type: 'alert-error', // Error message type
                                                        text: _(dat.AlertMessage), // Error message text
                                                    });
                                                } else {
                                                    webix // Create a window to display the PDF
                                                        .ui({
                                                            view: 'window',
                                                            width: 500, // Window width
                                                            height: 700, // Window height
                                                            head: {
                                                                view: 'toolbar', // Toolbar for the window
                                                                cols: [
                                                                    {
                                                                        view: 'label',
                                                                        label: _('Factura'), // Label for the window
                                                                    },
                                                                    {
                                                                        view: 'button',
                                                                        label: 'X', // Close button
                                                                        width: 100,
                                                                        align: 'right',
                                                                        click: '$$(\'windowfact2\').close();', // Close window action
                                                                    },
                                                                ],
                                                            },
                                                            id: 'windowfact2', // Window ID
                                                            modal: true, // Modal window
                                                            position: 'center', // Center position
                                                            body: {
                                                                rows: [
                                                                    {
                                                                        template:
                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for PDF display
                                                                    },
                                                                ],
                                                            },
                                                        })
                                                        .show(); // Show the window
                                                    var reader = new FileReader(); // File reader for PDF
                                                    reader.onload = function(event) { // On load event
                                                        $$('pdf').clear(); // Clear previous PDF
                                                        $$('pdf').parse({
                                                            data: event.target.result, // Parse new PDF data
                                                        });
                                                    };

                                                    function b64toBlob(b64Data, contentType, sliceSize) { // Function to convert Base64 to Blob
                                                        contentType = contentType || ''; // Default content type
                                                        sliceSize = sliceSize || 512; // Default slice size
                                                        var byteCharacters = atob(b64Data); // Decode Base64
                                                        var byteArrays = []; // Array to hold byte arrays
                                                        for (
                                                            var offset = 0;
                                                            offset < byteCharacters.length;
                                                            offset += sliceSize
                                                        ) {
                                                            var slice = byteCharacters.slice(
                                                                offset,
                                                                offset + sliceSize,
                                                            ); // Slice byte characters
                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                            for (var i = 0; i < slice.length; i++) {
                                                                byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                            }
                                                            var byteArray = new Uint8Array(byteNumbers); // Create byte array
                                                            byteArrays.push(byteArray); // Add to byte arrays
                                                        }
                                                        var blob = new Blob(byteArrays, { // Create Blob from byte arrays
                                                            type: contentType, // Set content type
                                                        });
                                                        return blob; // Return Blob
                                                    }

                                                    var contentType = 'application/pdf'; // PDF content type
                                                    var b64Data = dat.status_messagePdf; // Base64 PDF data from response
                                                    var blob = b64toBlob(b64Data, contentType); // Convert to Blob
                                                    var file = window.URL.createObjectURL(blob); // Create object URL for Blob
                                                    document.querySelector('iframe').src = file; // Set iframe source to Blob URL
                                                    var printWindow = window.open(file, '', 'width=800,height=500'); // Open print window
                                                    printWindow.print(); // Trigger print dialog
                                                }
                                            },
                                        });
                                }
                            },
                        });
                    },
                },
                on: { // Event handlers for the tree table
                    onBeforeLoad: function() { // Before loading event
                        this.showOverlay( // Show loading overlay
                            '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                        );
                    },
                    onAfterLoad: function() { // After loading event
                        this.hideOverlay(); // Hide loading overlay
                    },
                },
                ready: function() { // Ready event
                    if (!this.count()) { // Check if there are no rows
                        webix.extend(this, webix.OverlayBox); // Extend with overlay box
                        this.showOverlay( // Show no data overlay
                            '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' + _('No hay datos') + '</div>',
                        );
                    }
                },
                autowidth: false, // Disable auto width
                math: true, // Enable math calculations
                loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                leftSplit: leftSplit, // Left split configuration
                pager: 'pagerA', // Pager ID
            };
        } else {
            // Check for other partner selections
            if (devConfig.getPartnerSelected() == '1') {
                return {
                    view: 'treetable', // Specifies the view type as a tree table
                    css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                    id: 'CashResume', // Unique identifier for the component
                    bready: function() { // Function to execute when the component is ready
                        this.openAll(); // Expands all rows in the tree table
                    },
                    scrollY: true, // Enables vertical scrolling
                    columns: [ // Definition of columns in the tree table
                        {
                            id: 'Fecha', // Unique identifier for the column
                            header: _('Fecha'), // Header text for the column
                            width: 300, // Width of the column
                            template: function(obj, common) { // Template function to format cell content
                                if (obj.$group) return common.treetable(obj, common) + obj.value; // Returns formatted tree table cell
                                return obj.Fecha; // Returns the date value
                            },
                            footer: _('Total:'), // Footer text for the column
                        },
                        {
                            id: 'detailTittle', // Unique identifier for the column
                            header: '', // Header text for the column
                            width: 50, // Width of the column
                            height: 25, // Height of the column
                            tooltip: _('Detalles'), // Tooltip text for the column
                            template: function(obj) { // Template function to format cell content
                                if (obj.$level == 5) { // Checks if the level is 5
                                    return '<span placeholder=\'Imprimir\' class=\'webix_icon wxi-close printer\'></span>'; // Returns a print icon
                                } else {
                                    return ''; // Returns empty if not level 5
                                }
                            },
                        },
                        { id: 'UserId', header: _('ID Usuario'), width: 100 }, // Column for User ID
                        { id: 'Moneda', header: _('Moneda'), width: 70 }, // Column for Currency
                        {
                            id: 'CantidadTickets', // Unique identifier for the column
                            header: _('Cantidad Tickets'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.intFormat, // Formatting for integer values
                            width: 125, // Width of the column
                        },
                        {
                          id: 'ValorEntradasEfectivoDeportivo', // Recharge entry value column
                          header: _('Entradas en Efectivo - Apuestas Deportivas'), // Header text
                          footer: { content: 'summTreeColumn' }, // Footer content
                          format: webix.i18n.priceFormat, // Formatting function
                          exportType: 'number', // Export type
                          width: 160, // Column width
                        },
                        {
                            id: 'ValorEntradasEfectivoCasino', // Recharge entry value column
                            header: _('Entradas en Efectivo - Apuestas Virtuales'), // Header text
                            footer: { content: 'summTreeColumn' }, // Footer content
                            format: webix.i18n.priceFormat, // Formatting function
                            exportType: 'number', // Export type
                            width: 160, // Column width
                        },
                        {
                            id: 'VoidedPaidBets', // Unique identifier for the column
                            header: _('Apuestas Pagadas Anuladas'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 125, // Width of the column
                        },
                        {
                            id: 'ValorEntradasEfectivoNeto', // Unique identifier for the column
                            header: _('V.Entradas Efectivo Neto'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 135, // Width of the column
                        },
                        {
                            id: 'ValorEntradasBonoTC', // Unique identifier for the column
                            header: _('V.Entradas Bono/T.C'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 140, // Width of the column
                        },
                        {
                            id: 'ValorEntradasTraslados', // Unique identifier for the column
                            header: _('V.Entradas Traslados'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 145, // Width of the column
                        },
                        {
                            id: 'ValorEntradasRecargas', // Unique identifier for the column
                            header: _('V.Entradas Recargas'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 142, // Width of the column
                        },
                        {
                            id: 'Tax', // Unique identifier for the column
                            header: _('Impuestos'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 142, // Width of the column
                        },
                        {
                          id: 'ValorSalidaEfectivoDeportivas', // Recharge entry value column
                          header: _('Salida en Efectivo - Apuestas Deportivas'), // Header text
                          footer: { content: 'summTreeColumn' }, // Footer content
                          format: webix.i18n.priceFormat, // Formatting function
                          exportType: 'number', // Export type
                          width: 160, // Column width
                        },
                        {
                            id: 'ValorSalidaEfectivoCasino', // Recharge entry value column
                            header: _('Salida en Efectivo - Apuestas Virtuales'), // Header text
                            footer: { content: 'summTreeColumn' }, // Footer content
                            format: webix.i18n.priceFormat, // Formatting function
                            exportType: 'number', // Export type
                            width: 160, // Column width
                        },
                        {
                            id: 'VoidedPaidBets', // Unique identifier for the column
                            header: _('Apuestas Pagadas Anuladas'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 125, // Width of the column
                        },
                        {
                            id: 'ValorSalidasEfectivoNeto', // Unique identifier for the column
                            header: _('V.Salidas Efectivo Neto'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 125, // Width of the column
                        },
                        {
                            id: 'ValorSalidasTraslados', // Unique identifier for the column
                            header: _('V.Salidas Traslados'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 135, // Width of the column
                        },
                        {
                            id: 'ValorSalidasNotasRetiro', // Unique identifier for the column
                            header: _('V.Salidas N.Retiro'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 142, // Width of the column
                        },
                        {
                            id: 'Saldo', // Unique identifier for the column
                            header: _('Saldo'), // Header text for the column
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            format: webix.i18n.priceFormat, // Formatting for price values
                            exportType: 'number', // Specifies the export type
                            width: 100, // Width of the column
                        },
                    ],
                    onClick: { // Event handler for click events
                        printer: function(euv, id) { // Function to handle printing
                            var vvthis = this; // Reference to the current context
                            webix.confirm({ // Confirmation dialog for printing
                                type: 'confirm-warning',
                                text: _('Advertencia!') + '<br/>' + _('Desea imprimir recibo?'), // Confirmation message
                                ok: _('Imprimir'), // Text for the OK button
                                cancel: _('Salir'), // Text for the Cancel button
                                callback: function(action) { // Callback function for the confirmation
                                    if (action === true) { // If confirmed
                                        let time = new Date().toLocaleTimeString(); // Get current time
                                        var item = vvthis.getItem(id); // Get the item associated with the clicked row
                                        console.log(item); // Log the item to the console
                                        var shtml = // HTML template for the printed receipt
                                            `<p style="text-align:center;">
                                        &nbsp;
                                      </p>
                                      <p style="text-align:center;">
                                        &nbsp;
                                      </p>
                                      <figure class="table">
                                      <table style="border:1px solid hsl(0, 0%, 0%);">
                                        <tbody>
                                          <tr>
                                            <td style="background-color:hsl(0, 0%, 90%);text-align:center;width:50%;">
                                              <h4>
                                                <span style="color:#6a8759;">` +
                                            _('Flujo Caja Resumido') +
                                            `</span>
                                              </h4>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </figure>
                                    <hr>
                                      <figure class="table" style="width:100%;">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Fecha') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            item.Fecha +
                                            ' ' +
                                            time +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                             <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Punto de Venta') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            item.Punto +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Cajeros') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            item.UserNameCreator +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Moneda') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            item.Moneda +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Cantidad Tickets') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            item.CantidadTickets +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Entradas en Efectivo - Apuestas Deportivas') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorEntradasEfectivoDeportivo) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V. Entradas Efectivo Casino') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorEntradasEfectivoCasino) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Apuestas Pagadas Anuladas') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.VoidedPaidBets) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Entradas Efectivo Neto') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorEntradasEfectivoNeto) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Entradas Bono/T.C') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorEntradasBonoTC) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Entradas Traslados') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorEntradasTraslados) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Entradas Recargas') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorEntradasRecargas) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Impuestos') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.Tax) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Salidas Efectivo Deportivas') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorSalidaEfectivoDeportivas) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Salidas Efectivo Casino') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorSalidaEfectivoCasino) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Apuestas Pagadas Anuladas') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.VoidedPaidBets) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Salidas Efectivo Neto') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorSalidasEfectivoNeto) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Salidas Traslados') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorSalidasTraslados) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('V.Salidas N.Retiro') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.ValorSalidasNotasRetiro) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="width:50%;">
                                                <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                            _('Saldo') +
                                            `</span>
                                              </td>
                                              <td style="text-align:right;width:50%;">
                                                <p style="text-align:right;">
                                                  <span class="mention" '>` +
                                            webix.i18n.priceFormat(item.Saldo) +
                                            `</span>&nbsp;
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </figure>`;
                                        var parameters = { // Parameters for the AJAX request
                                            Template: shtml, // HTML template for the receipt
                                        };
                                        const json = JSON.stringify(parameters, (key, val) => { // Convert parameters to JSON
                                            if (typeof val === 'string') {
                                                return val
                                                    .replace(/ñ/g, '&#241;') // Encode special characters
                                                    .replace(/Ñ/g, '&#209;')
                                                    .replace(/á/g, '&#225;')
                                                    .replace(/Á/g, '&#193;')
                                                    .replace(/é/g, '&#233;')
                                                    .replace(/É/g, '&#201;')
                                                    .replace(/í/g, '&#237;')
                                                    .replace(/Í/g, '&#205;')
                                                    .replace(/ó/g, '&#243;')
                                                    .replace(/Ó/g, '&#211;')
                                                    .replace(/ú/g, '&#250;')
                                                    .replace(/Ú/g, '&#218;');
                                            }
                                            return val; // Return the value as is
                                        });
                                        var objJsonB64 = btoa(unescape(encodeURIComponent(json))); // Encode JSON to Base64
                                        webix // AJAX request to send the template for preview
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type to JSON
                                            })
                                            .post(
                                                devConfig.geturlApi() + '/ApiMkt/Templates/PreviewTemplate', // API endpoint
                                                objJsonB64, // Base64 encoded JSON
                                                {
                                                    error: function(text, data, XmlHttpRequest) { // Error handling
                                                        webix.message('Error! '); // Display error message
                                                    },
                                                    success: function(text, data, XmlHttpRequest) { // Success handling
                                                        var dat = JSON.parse(text); // Parse response data
                                                        if (dat.HasError) { // Check for errors in response
                                                            webix.message({
                                                                title: '¡Error!', // Error message title
                                                                type: 'alert-error', // Error message type
                                                                text: _(dat.AlertMessage), // Error message text
                                                            });
                                                        } else {
                                                            webix // Create a modal window to display the PDF
                                                                .ui({
                                                                    view: 'window',
                                                                    width: 500,
                                                                    height: 700,
                                                                    head: {
                                                                        view: 'toolbar',
                                                                        cols: [
                                                                            {
                                                                                view: 'label',
                                                                                label: _('Factura'), // Window title
                                                                            },
                                                                            {
                                                                                view: 'button',
                                                                                label: 'X', // Close button
                                                                                width: 100,
                                                                                align: 'right',
                                                                                click: '$$(\'windowfact2\').close();', // Close window action
                                                                            },
                                                                        ],
                                                                    },
                                                                    id: 'windowfact2', // Unique identifier for the window
                                                                    modal: true, // Modal window
                                                                    position: 'center', // Center position
                                                                    body: {
                                                                        rows: [
                                                                            {
                                                                                template:
                                                                                    '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for PDF display
                                                                            },
                                                                        ],
                                                                    },
                                                                })
                                                                .show(); // Show the modal window
                                                            var reader = new FileReader(); // FileReader to read the PDF
                                                            reader.onload = function(event) { // On load event
                                                                $$('pdf').clear(); // Clear previous PDF
                                                                $$('pdf').parse({
                                                                    data: event.target.result, // Parse new PDF data
                                                                });
                                                            };

                                                            function b64toBlob(b64Data, contentType, sliceSize) { // Function to convert Base64 to Blob
                                                                contentType = contentType || ''; // Default content type
                                                                sliceSize = sliceSize || 512; // Default slice size
                                                                var byteCharacters = atob(b64Data); // Decode Base64
                                                                var byteArrays = []; // Array to hold byte arrays
                                                                for (
                                                                    var offset = 0;
                                                                    offset < byteCharacters.length;
                                                                    offset += sliceSize
                                                                ) {
                                                                    var slice = byteCharacters.slice(
                                                                        offset,
                                                                        offset + sliceSize,
                                                                    ); // Slice byte characters
                                                                    var byteNumbers = new Array(slice.length); // Create byte numbers array
                                                                    for (var i = 0; i < slice.length; i++) {
                                                                        byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                    }
                                                                    var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array from byte numbers
                                                                    byteArrays.push(byteArray); // Push byte array to the array
                                                                }
                                                                var blob = new Blob(byteArrays, { // Create Blob from byte arrays
                                                                    type: contentType, // Set content type
                                                                });
                                                                return blob; // Return the Blob
                                                            }

                                                            var contentType = 'application/pdf'; // Content type for PDF
                                                            var b64Data = dat.status_messagePdf; // Base64 data for PDF
                                                            var blob = b64toBlob(b64Data, contentType); // Convert Base64 to Blob
                                                            var file = window.URL.createObjectURL(blob); // Create object URL for Blob
                                                            document.querySelector('iframe').src = file; // Set iframe source to the Blob URL
                                                            var printWindow = window.open( // Open new window for printing
                                                                file,
                                                                '',
                                                                'width=800,height=500',
                                                            );
                                                            printWindow.print(); // Trigger print dialog
                                                        }
                                                    },
                                                },
                                            );
                                    }
                                },
                            });
                        },
                    },
                    on: { // Event handlers for the component
                        onBeforeLoad: function() { // Before loading data
                            this.showOverlay( // Show loading overlay
                                '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                            );
                        },
                        onAfterLoad: function() { // After loading data
                            this.hideOverlay(); // Hide loading overlay
                        },
                    },
                    ready: function() { // Function to execute when the component is ready
                        if (!this.count()) { // Check if there are no items
                            webix.extend(this, webix.OverlayBox); // Extend with overlay box functionality
                            this.showOverlay( // Show no data overlay
                                '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' +
                                _('No hay datos') +
                                '</div>',
                            );
                        }
                    },
                    autowidth: false, // Disable automatic width adjustment
                    math: true, // Enable mathematical operations
                    loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                    leftSplit: leftSplit, // Set left split configuration
                    pager: 'pagerA', // Set pager identifier
                };
            } else {
                if (devConfig.getPartnerSelected() == '2') {
                    return {
                        view: 'treetable', // Defines the view type as a tree table
                        css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                        id: 'CashResume', // Unique identifier for the component
                        bready: function() { // Function to execute when the component is ready
                            this.openAll(); // Expands all rows in the tree table
                        },
                        scrollY: true, // Enables vertical scrolling
                        columns: [ // Array defining the columns of the tree table
                            {
                                id: 'Fecha', // Unique identifier for the column
                                header: _('Fecha'), // Header text for the column
                                width: 300, // Width of the column
                                template: function(obj, common) { // Template function for rendering cell content
                                    if (obj.$group) return common.treetable(obj, common) + obj.value; // Renders group rows
                                    return obj.Fecha; // Returns the date value for regular rows
                                },
                                footer: _('Total:'), // Footer text for the column
                            },
                            {
                                id: 'detailTittle', // Unique identifier for the column
                                header: '', // Header text for the column
                                width: 50, // Width of the column
                                height: 25, // Height of the column
                                tooltip: _('Detalles'), // Tooltip text for the column
                                template: function(obj) { // Template function for rendering cell content
                                    if (obj.$level == 5) { // Checks if the level is 5
                                        return '<span placeholder=\'Imprimir\' class=\'webix_icon wxi-close printer\'></span>'; // Returns a print icon
                                    } else {
                                        return ''; // Returns empty for other levels
                                    }
                                },
                            },
                            {
                                id: 'UserId', // Unique identifier for the column
                                header: _('ID Usuario'), // Header text for the column
                                width: 100, // Width of the column
                            },
                            { id: 'Moneda', header: _('Moneda'), width: 70 }, // Column for currency
                            {
                                id: 'CantidadTickets', // Unique identifier for the column
                                header: _('Cantidad Tickets'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.intFormat, // Format for integer values
                                width: 125, // Width of the column
                            },
                            {
                                id: 'ValorEntradasEfectivoDeportivo', // Recharge entry value column
                                header: _('Entradas en Efectivo - Apuestas Deportivas'), // Header text
                                footer: { content: 'summTreeColumn' }, // Footer content
                                format: webix.i18n.priceFormat, // Formatting function
                                exportType: 'number', // Export type
                                width: 160, // Column width
                            },
                            {
                                id: 'ValorEntradasEfectivoCasino', // Recharge entry value column
                                header: _('Entradas en Efectivo - Apuestas Virtuales'), // Header text
                                footer: { content: 'summTreeColumn' }, // Footer content
                                format: webix.i18n.priceFormat, // Formatting function
                                exportType: 'number', // Export type
                                width: 160, // Column width
                            },
                            {
                                id: 'VoidedPaidBets', // Unique identifier for the column
                                header: _('Apuestas Pagadas Anuladas'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 125, // Width of the column
                            },
                            {
                                id: 'ValorEntradasEfectivoNeto', // Unique identifier for the column
                                header: _('V.Entradas Efectivo Neto'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 135, // Width of the column
                            },
                            {
                                id: 'ValorEntradasBonoTC', // Unique identifier for the column
                                header: _('V.Entradas Bono/T.C'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 140, // Width of the column
                            },
                            {
                                id: 'ValorEntradasTraslados', // Unique identifier for the column
                                header: _('V.Entradas Traslados'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 145, // Width of the column
                            },
                            {
                                id: 'ValorEntradasRecargas', // Unique identifier for the column
                                header: _('V.Entradas Recargas'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 142, // Width of the column
                            },
                            {
                                id: 'Tax', // Unique identifier for the column
                                header: _('Impuestos'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 142, // Width of the column
                            },
                            {
                                id: 'ValorSalidaEfectivoDeportivas', // Recharge entry value column
                                header: _('Salida en Efectivo - Apuestas Deportivas'), // Header text
                                footer: { content: 'summTreeColumn' }, // Footer content
                                format: webix.i18n.priceFormat, // Formatting function
                                exportType: 'number', // Export type
                                width: 160, // Column width
                            },
                            {
                                id: 'ValorSalidaEfectivoCasino', // Recharge entry value column
                                header: _('Salida en Efectivo - Apuestas Virtuales'), // Header text
                                footer: { content: 'summTreeColumn' }, // Footer content
                                format: webix.i18n.priceFormat, // Formatting function
                                exportType: 'number', // Export type
                                width: 160, // Column width
                            },
                            {
                                id: 'VoidedPaidBets', // Unique identifier for the column
                                header: _('Apuestas Pagadas Anuladas'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 125, // Width of the column
                            },
                            {
                                id: 'ValorSalidasEfectivoNeto', // Unique identifier for the column
                                header: _('V.Salidas Efectivo Neto'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 125, // Width of the column
                            },
                            {
                                id: 'ValorSalidasTraslados', // Unique identifier for the column
                                header: _('V.Salidas Traslados'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 135, // Width of the column
                            },
                            {
                                id: 'ValorSalidasNotasRetiro', // Unique identifier for the column
                                header: _('V.Salidas N.Retiro'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 142, // Width of the column
                            },
                            {
                                id: 'Saldo', // Unique identifier for the column
                                header: _('Saldo'), // Header text for the column
                                footer: { content: 'summTreeColumn' }, // Footer content for summation
                                format: webix.i18n.priceFormat, // Format for price values
                                exportType: 'number', // Export type for the column
                                width: 100, // Width of the column
                            },
                        ],
                        onClick: { // Event handler for click events
                            printer: function(euv, id) { // Function to handle printing action
                                var vvthis = this; // Reference to the current context
                                webix.confirm({ // Confirmation dialog for printing
                                    type: 'confirm-warning',
                                    text: _('Advertencia!') + '<br/>' + _('Desea imprimir recibo?'), // Confirmation message
                                    ok: _('Imprimir'), // Text for the OK button
                                    cancel: _('Salir'), // Text for the Cancel button
                                    callback: function(action) { // Callback function for the confirmation dialog
                                        if (action === true) { // If confirmed
                                            let time = new Date().toLocaleTimeString(); // Get current time
                                            var item = vvthis.getItem(id); // Get the item data for the clicked row
                                            console.log(item); // Log the item data
                                            var shtml = // HTML template for the receipt
                                                `<p style="text-align:center;">
                                    &nbsp;
                                  </p>
                                  <p style="text-align:center;">
                                    &nbsp;
                                  </p>
                                  <figure class="table">
                                  <table style="border:1px solid hsl(0, 0%, 0%);">
                                    <tbody>
                                      <tr>
                                        <td style="background-color:hsl(0, 0%, 90%);text-align:center;width:50%;">
                                          <h4>
                                            <span style="color:#6a8759;">` +
                                                _('Flujo Caja Resumido') +
                                                `</span>
                                          </h4>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </figure>
                                <hr>
                                  <figure class="table" style="width:100%;">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Fecha') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                item.Fecha +
                                                ' ' +
                                                time +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Punto de Venta') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                item.Punto +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Cajeros') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                item.UserNameCreator +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Moneda') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                item.Moneda +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Cantidad Tickets') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                item.CantidadTickets +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Entradas en Efectivo - Apuestas Deportivas') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorEntradasEfectivoDeportivo) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Entradas en Efectivo - Apuestas Virtuales') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorEntradasEfectivoCasino) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Apuestas Pagadas Anuladas') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.VoidedPaidBets) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Entradas Efectivo Neto') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorEntradasEfectivoNeto) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Entradas Bono/T.C') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorEntradasBonoTC) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Entradas Traslados') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorEntradasTraslados) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Entradas Recargas') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorEntradasRecargas) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Impuestos') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.Tax) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Salidas Efectivo Deportivas') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorSalidaEfectivoDeportivas) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Salidas Efectivo Casino') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorSalidaEfectivoCasino) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Apuestas Pagadas Anuladas') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.VoidedPaidBets) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Salidas Efectivo Neto') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorSalidasEfectivoNeto) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Salidas Traslados') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorSalidasTraslados) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('V.Salidas N.Retiro') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.ValorSalidasNotasRetiro) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="width:50%;">
                                            <span style="background-color:rgb(255,255,255);color:rgb(0,0,0);font-family:Arial, Helvetica, sans-serif;">` +
                                                _('Saldo') +
                                                `</span>
                                          </td>
                                          <td style="text-align:right;width:50%;">
                                            <p style="text-align:right;">
                                              <span class="mention" '>` +
                                                webix.i18n.priceFormat(item.Saldo) +
                                                `</span>&nbsp;
                                            </p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </figure>`;
                                            var parameters = { // Parameters for the AJAX request
                                                Template: shtml, // HTML template for the receipt
                                            };
                                            const json = JSON.stringify(parameters, (key, val) => { // Convert parameters to JSON
                                                if (typeof val === 'string') { // Check if the value is a string
                                                    return val
                                                        .replace(/ñ/g, '&#241;') // Replace special characters for encoding
                                                        .replace(/Ñ/g, '&#209;')
                                                        .replace(/á/g, '&#225;')
                                                        .replace(/Á/g, '&#193;')
                                                        .replace(/é/g, '&#233;')
                                                        .replace(/É/g, '&#201;')
                                                        .replace(/í/g, '&#237;')
                                                        .replace(/Í/g, '&#205;')
                                                        .replace(/ó/g, '&#243;')
                                                        .replace(/Ó/g, '&#211;')
                                                        .replace(/ú/g, '&#250;')
                                                        .replace(/Ú/g, '&#218;');
                                                }
                                                return val; // Return the value as is
                                            });
                                            var objJsonB64 = btoa(unescape(encodeURIComponent(json))); // Encode JSON to Base64
                                            webix // AJAX request to send the template for preview
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + '/ApiMkt/Templates/PreviewTemplate', // API endpoint
                                                    objJsonB64, // Base64 encoded JSON
                                                    {
                                                        error: function(text, data, XmlHttpRequest) { // Error callback
                                                            webix.message('Error! '); // Display error message
                                                        },
                                                        success: function(text, data, XmlHttpRequest) { // Success callback
                                                            var dat = JSON.parse(text); // Parse the response
                                                            if (dat.HasError) { // Check for errors in the response
                                                                webix.message({
                                                                    title: '¡Error!', // Error message title
                                                                    type: 'alert-error', // Error message type
                                                                    text: _(dat.AlertMessage), // Error message text
                                                                });
                                                            } else {
                                                                webix // Create a modal window to display the PDF
                                                                    .ui({
                                                                        view: 'window',
                                                                        width: 500,
                                                                        height: 700,
                                                                        head: {
                                                                            view: 'toolbar',
                                                                            cols: [
                                                                                {
                                                                                    view: 'label',
                                                                                    label: _('Factura'), // Window title
                                                                                },
                                                                                {
                                                                                    view: 'button',
                                                                                    label: 'X', // Close button
                                                                                    width: 100,
                                                                                    align: 'right',
                                                                                    click: '$$(\'windowfact2\').close();', // Close action
                                                                                },
                                                                            ],
                                                                        },
                                                                        id: 'windowfact2', // Unique identifier for the window
                                                                        modal: true, // Modal window
                                                                        position: 'center', // Center position
                                                                        body: {
                                                                            rows: [
                                                                                {
                                                                                    template:
                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for PDF display
                                                                                },
                                                                            ],
                                                                        },
                                                                    })
                                                                    .show(); // Show the modal window
                                                                var reader = new FileReader(); // FileReader to read the PDF
                                                                reader.onload = function(event) { // On load event
                                                                    $$('pdf').clear(); // Clear previous PDF
                                                                    $$('pdf').parse({
                                                                        data: event.target.result, // Parse the new PDF data
                                                                    });
                                                                };

                                                                function b64toBlob(b64Data, contentType, sliceSize) { // Function to convert Base64 to Blob
                                                                    contentType = contentType || ''; // Default content type
                                                                    sliceSize = sliceSize || 512; // Default slice size
                                                                    var byteCharacters = atob(b64Data); // Decode Base64
                                                                    var byteArrays = []; // Array to hold byte arrays
                                                                    for (
                                                                        var offset = 0;
                                                                        offset < byteCharacters.length;
                                                                        offset += sliceSize
                                                                    ) {
                                                                        var slice = byteCharacters.slice(
                                                                            offset,
                                                                            offset + sliceSize,
                                                                        ); // Slice the byte characters
                                                                        var byteNumbers = new Array(slice.length); // Create array for byte numbers
                                                                        for (var i = 0; i < slice.length; i++) {
                                                                            byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                                                        }
                                                                        var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array from byte numbers
                                                                        byteArrays.push(byteArray); // Push byte array to the array
                                                                    }
                                                                    var blob = new Blob(byteArrays, {
                                                                        type: contentType, // Create Blob with content type
                                                                    });
                                                                    return blob; // Return the Blob
                                                                }

                                                                var contentType = 'application/pdf'; // Content type for PDF
                                                                var b64Data = dat.status_messagePdf; // Base64 data for PDF
                                                                var blob = b64toBlob(b64Data, contentType); // Convert Base64 to Blob
                                                                var file = window.URL.createObjectURL(blob); // Create object URL for the Blob
                                                                document.querySelector('iframe').src = file; // Set iframe source to the Blob URL
                                                                var printWindow = window.open(
                                                                    file,
                                                                    '',
                                                                    'width=800,height=500', // Open print window
                                                                );
                                                                printWindow.print(); // Trigger print dialog
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                });
                            },
                        },
                        on: { // Event handlers for the component
                            onBeforeLoad: function() { // Before load event
                                this.showOverlay( // Show loading overlay
                                    '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                                );
                            },
                            onAfterLoad: function() { // After load event
                                this.hideOverlay(); // Hide loading overlay
                            },
                        },
                        ready: function() { // Function to execute when the component is ready
                            if (!this.count()) { // Check if there are no rows
                                webix.extend(this, webix.OverlayBox); // Extend with overlay box functionality
                                this.showOverlay( // Show no data overlay
                                    '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' +
                                    _('No hay datos') +
                                    '</div>',
                                );
                            }
                        },
                        autowidth: false, // Disable automatic width adjustment
                        math: true, // Enable mathematical operations
                        loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
                        leftSplit: leftSplit, // Left split configuration
                        pager: 'pagerA', // Pager configuration
                    };
                } else {
                    if (devConfig.getPartnerSelected() == '8') {
                        return { // Return tree table configuration for partner '8'
                            view: 'treetable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            id: 'CashResume',
                            bready: function() {
                                this.openAll(); // Open all rows
                            },
                            scrollY: true, // Enable vertical scrolling
                            columns: [ // Define columns
                                {
                                    id: 'Fecha',
                                    header: _('Fecha'), // Column header with translation
                                    width: 300, // Column width
                                    template: function(obj, common) { // Template function for cell rendering
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Render group rows
                                        return obj.Fecha; // Return the date value
                                    },
                                    footer: _('Total:'), // Footer content with translation
                                },
                                {
                                    id: 'UserId', // User ID column
                                    header: _('ID Usuario'), // Column header with translation
                                    width: 100,
                                },
                                {
                                    id: 'Moneda', // Currency column
                                    header: _('Moneda'), // Column header with translation
                                    width: 70,
                                },
                                {
                                    id: 'CantidadTickets', // Tickets count column
                                    header: _('Cantidad Tickets'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.intFormat, // Format for integer values
                                    width: 125, // Column width
                                },
                                {
                                    id: 'ValorEntradasEfectivoDeportivo', // Recharge entry value column
                                    header: _('Entradas en Efectivo - Apuestas Deportivas'), // Header text
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 160, // Column width
                                },
                                {
                                    id: 'ValorEntradasEfectivoCasino', // Recharge entry value column
                                    header: _('Entradas en Efectivo - Apuestas Virtuales'), // Header text
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 160, // Column width
                                },
                                {
                                    id: 'VoidedPlacedBets', // Voided bets column
                                    header: _('Apuestas Anuladas'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 135, // Column width
                                },
                                {
                                    id: 'ValorEntradasEfectivoNeto', // Net cash entries value column
                                    header: _('V.Entradas Efectivo Neto'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 135, // Column width
                                },
                                {
                                    id: 'ValorEntradasBonoTC', // Bonus/T.C entries value column
                                    header: _('V.Entradas Bono/T.C'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 140, // Column width
                                },
                                {
                                    id: 'ValorEntradasTraslados', // Transfers entries value column
                                    header: _('V.Entradas Traslados'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 145, // Column width
                                },
                                {
                                    id: 'ValorEntradasRecargas', // Reload entries value column
                                    header: _('V.Entradas Recargas'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'ValorEntradasRecargasAgentes', // Agent reload entries value column
                                    header: _('V. Entradas Recargas Agentes'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'RecargasAnuladas', // Voided reloads column
                                    header: _('Recargas Anuladas'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'Tax', // Tax column
                                    header: _('Impuestos'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'ValorSalidaEfectivoDeportivas', // Recharge entry value column
                                    header: _('Salida en Efectivo - Apuestas Deportivas'), // Header text
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 160, // Column width
                                },
                                {
                                    id: 'ValorSalidaEfectivoCasino', // Recharge entry value column
                                    header: _('Salida en Efectivo - Apuestas Virtuales'), // Header text
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 160, // Column width
                                },
                                {
                                    id: 'VoidedPaidBets', // Voided paid bets column
                                    header: _('Apuestas Pagadas Anuladas'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 125, // Column width
                                },
                                {
                                    id: 'ValorSalidasEfectivoNeto', // Net cash exits value column
                                    header: _('V.Salidas Efectivo Neto'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 125, // Column width
                                },
                                {
                                    id: 'ValorSalidasTraslados', // Transfers exits value column
                                    header: _('V.Salidas Traslados'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 135, // Column width
                                },
                                {
                                    id: 'ValorSalidasNotasRetiro', // Withdrawal notes exits value column
                                    header: _('V.Salidas N.Retiro'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'ValorSalidasNotasRetiroRetail', // Retail withdrawal notes exits value column
                                    header: _('V.Salidas N.Retiro Retail'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'Saldo', // Balance column
                                    header: _('Saldo'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 100, // Column width
                                },
                            ],
                            on: { // Event handlers for the tree table
                                onBeforeLoad: function() { // Before loading event
                                    this.showOverlay( // Show loading overlay
                                        '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                                    );
                                },
                                onAfterLoad: function() { // After loading event
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function() { // Ready event
                                if (!this.count()) { // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay( // Show no data overlay
                                        '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' +
                                        _('No hay datos') +
                                        '</div>',
                                    );
                                }
                            },
                            autowidth: false, // Disable auto width
                            math: true, // Enable math calculations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            leftSplit: leftSplit, // Left split configuration
                            pager: 'pagerA', // Pager ID
                        };
                    } else {
                        return { // Default tree table configuration
                            view: 'treetable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            id: 'CashResume',
                            bready: function() {
                                this.openAll(); // Open all rows
                            },
                            scrollY: true, // Enable vertical scrolling
                            columns: [ // Define columns
                                {
                                    id: 'Fecha',
                                    header: _('Fecha'), // Column header with translation
                                    width: 300, // Column width
                                    template: function(obj, common) { // Template function for cell rendering
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Render group rows
                                        return obj.Fecha; // Return the date value
                                    },
                                    footer: _('Total:'), // Footer content with translation
                                },
                                {
                                    id: 'UserId', // User ID column
                                    header: _('ID Usuario'), // Column header with translation
                                    width: 100,
                                },
                                {
                                    id: 'Moneda', // Currency column
                                    header: _('Moneda'), // Column header with translation
                                    width: 70,
                                },
                                {
                                    id: 'CantidadTickets', // Tickets count column
                                    header: _('Cantidad Tickets'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.intFormat, // Format for integer values
                                    width: 125, // Column width
                                },
                                {
                                    id: 'ValorEntradasEfectivoDeportivo', // Recharge entry value column
                                    header: _('Entradas en Efectivo - Apuestas Deportivas'), // Header text
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 160, // Column width
                                },
                                {
                                    id: 'ValorEntradasEfectivoCasino', // Recharge entry value column
                                    header: _('Entradas en Efectivo - Apuestas Virtuales'), // Header text
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 160, // Column width
                                },
                                {
                                    id: 'VoidedPlacedBets', // Voided bets column
                                    header: _('Apuestas Anuladas'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 135, // Column width
                                },
                                {
                                    id: 'ValorEntradasEfectivoNeto', // Net cash entries value column
                                    header: _('V.Entradas Efectivo Neto'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 135, // Column width
                                },
                                {
                                    id: 'ValorEntradasBonoTC', // Bonus/T.C entries value column
                                    header: _('V.Entradas Bono/T.C'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 140, // Column width
                                },
                                {
                                    id: 'ValorEntradasTraslados', // Transfers entries value column
                                    header: _('V.Entradas Traslados'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 145, // Column width
                                },
                                {
                                    id: 'ValorEntradasRecargas', // Reload entries value column
                                    header: _('V.Entradas Recargas'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'RecargasAnuladas', // Voided reloads column
                                    header: _('Recargas Anuladas'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'Tax', // Tax column
                                    header: _('Impuestos'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'ValorSalidaEfectivoDeportivas', // Recharge entry value column
                                    header: _('Salida en Efectivo - Apuestas Deportivas'), // Header text
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 160, // Column width
                                },
                                {
                                    id: 'ValorSalidaEfectivoCasino', // Recharge entry value column
                                    header: _('Salida en Efectivo - Apuestas Virtuales'), // Header text
                                    footer: { content: 'summTreeColumn' }, // Footer content
                                    format: webix.i18n.priceFormat, // Formatting function
                                    exportType: 'number', // Export type
                                    width: 160, // Column width
                                },
                                {
                                    id: 'VoidedPaidBets', // Voided paid bets column
                                    header: _('Apuestas Pagadas Anuladas'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 125, // Column width
                                },
                                {
                                    id: 'ValorSalidasEfectivoNeto', // Net cash exits value column
                                    header: _('V.Salidas Efectivo Neto'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 125, // Column width
                                },
                                {
                                    id: 'ValorSalidasTraslados', // Transfers exits value column
                                    header: _('V.Salidas Traslados'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 135, // Column width
                                },
                                {
                                    id: 'ValorSalidasNotasRetiro', // Withdrawal notes exits value column
                                    header: _('V.Salidas N.Retiro'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 142, // Column width
                                },
                                {
                                    id: 'Saldo', // Balance column
                                    header: _('Saldo'), // Column header with translation
                                    footer: { content: 'summTreeColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Format for price values
                                    exportType: 'number', // Export type for this column
                                    width: 100, // Column width
                                },
                            ],
                            on: { // Event handlers for the tree table
                                onBeforeLoad: function() { // Before loading event
                                    this.showOverlay( // Show loading overlay
                                        '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                                    );
                                },
                                onAfterLoad: function() { // After loading event
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function() { // Ready event
                                if (!this.count()) { // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                    this.showOverlay( // Show no data overlay
                                        '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' +
                                        _('No hay datos') +
                                        '</div>',
                                    );
                                }
                            },
                            autowidth: false, // Disable auto width
                            math: true, // Enable math calculations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            leftSplit: leftSplit, // Left split configuration
                            pager: 'pagerA', // Pager ID
                        };
                    }
                }
            }
        }
    }

    /**
     * Initializes the grid with data and event handlers.
     * @param {Object} grid - The grid object to be initialized.
     */
    init(grid) {
        // Construct the API URL for fetching summarized cash flow data.
        var url = devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumido';

        // Attach an event handler that triggers after the grid has loaded data.
        grid.attachEvent('onAfterLoad', function() {
            // Group data by 'Punto' and map relevant fields for aggregation.
            $$('CashResume').data.group({
                by: 'Punto',
                map: {
                    Partner: ['Partner'],
                    Punto: ['Punto'],
                    Agent: ['Agent'],
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Moneda: ['Moneda'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivoDeportivo: ['ValorEntradasEfectivoDeportivo', 'sum'],
                    ValorEntradasEfectivoCasino: ['ValorEntradasEfectivoCasino', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    ValorEntradasRecargasAgentes: ['ValorEntradasRecargasAgentes', 'sum'],
                    RecargasAnuladas: ['RecargasAnuladas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidaEfectivoDeportivas: ['ValorSalidaEfectivoDeportivas', 'sum'],
                    ValorSalidaEfectivoCasino: ['ValorSalidaEfectivoCasino', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    ValorSalidasNotasRetiroRetail: ['ValorSalidasNotasRetiroRetail', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            // Group data by 'Agent' and map relevant fields for aggregation.
            $$('CashResume').data.group({
                by: 'Agent',
                map: {
                    Partner: ['Partner'],
                    Agent: ['Agent'],
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Moneda: ['Moneda'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivoDeportivo: ['ValorEntradasEfectivoDeportivo', 'sum'],
                    ValorEntradasEfectivoCasino: ['ValorEntradasEfectivoCasino', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    ValorEntradasRecargasAgentes: ['ValorEntradasRecargasAgentes', 'sum'],
                    RecargasAnuladas: ['RecargasAnuladas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidaEfectivoDeportivas: ['ValorSalidaEfectivoDeportivas', 'sum'],
                    ValorSalidaEfectivoCasino: ['ValorSalidaEfectivoCasino', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    ValorSalidasNotasRetiroRetail: ['ValorSalidasNotasRetiroRetail', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            // Group data by country using a custom function for display.
            $$('CashResume').data.group({
                by: function(obj) {
                    return '<i class=\'flags ' + obj.CountryIcon + '\'></i>' + obj.CountryId;
                },
                map: {
                    Moneda: ['Moneda'],
                    Partner: ['Partner'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivoDeportivo: ['ValorEntradasEfectivoDeportivo', 'sum'],
                    ValorEntradasEfectivoCasino: ['ValorEntradasEfectivoCasino', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    ValorEntradasRecargasAgentes: ['ValorEntradasRecargasAgentes', 'sum'],
                    RecargasAnuladas: ['RecargasAnuladas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidaEfectivoDeportivas: ['ValorSalidaEfectivoDeportivas', 'sum'],
                    ValorSalidaEfectivoCasino: ['ValorSalidaEfectivoCasino', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    ValorSalidasNotasRetiroRetail: ['ValorSalidasNotasRetiroRetail', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            // Group data by partner using a custom function for display.
            $$('CashResume').data.group({
                by: function(obj) {
                    return (
                        '<i style=\'background-image:url(' +
                        profile.Partners.filter((item) => {
                            return item.id == obj.Partner;
                        })[0].image +
                        ') !important;\' class=\'partner ' +
                        obj.Partner +
                        '\'></i>'
                    );
                },
                map: {
                    Partner: ['Partner'],
                    Moneda: [],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                },
            });
        });

        // Listen for filter events and update the grid based on filter data.
        this.on(this.app, 'flujoCajaResumido:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            // Iterate through filter data to construct query string.
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'DateCreatedBetShop') {
                            var date = object[i][1].split(' - ');
                            string1 = string1 + '&dateCreatedBetShopFrom=' + date[0];
                            string1 = string1 + '&dateCreatedBetShopTo=' + date[1];
                        } else {
                            if (object[i][0] != 'Date' && object[i][0] != 'DateCreatedBetShop2') {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                            } else {
                                if (object[i][0] == 'Date') {
                                    var date = object[i][1].replace(' 00:00:00', '');
                                    string1 = string1 + '&dateFrom=' + date;
                                    string1 = string1 + '&dateTo=' + date;
                                }
                                if (object[i][0] == 'DateCreatedBetShop2') {
                                    var date = object[i][1].replace(' 00:00:00', '');
                                    string1 = string1 + '&dateCreatedBetShopFrom=' + date;
                                    string1 = string1 + '&dateCreatedBetShopTo=' + date;
                                }
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through nested filter data for date range.
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Clear the grid and load new data based on the constructed URL.
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Hide the filter popup after applying the filter.
            $$('filterPopup').hide();
        });

        // Attach an event handler for item clicks in the grid.
        grid.attachEvent('onItemClick', function(id, e, node) {
            var item = this.getItem(id);
            // Trigger a user ID event with the clicked item's ID.
            this.$scope.app.callEvent('user:id', [item.Id]);
        });

        // Listen for player selection events and load data based on selected player ID.
        this.on(this.app, 'player:select', (Id) => {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id);
        });
    }
}

// FILE DOCUMENTED
